module.exports = __webpack_public_path__ + "/login_ui/img/tw-b5ab3e339cf7e44bda210b3cdf4a6d5c.svg";